module.exports = __webpack_public_path__ + "static/media/wtof-1.d5d5c960.png";